import { getAuthAxios } from "@artprov/design-system";

const paths = {
  getAll: "tipoComprobante",
};

export const getTipoComprobante = async () => {
  const response = await getAuthAxios("default").get(paths.getAll);
  return response;
};